module.exports = __webpack_public_path__ + "img/Sam Watson.31491fa9.jpg";